import { createSelector } from 'reselect'

import getActivityList from 'helpers/interactive_video/activity_list'
import featureFlagsSelectorCreator from 'redux/selectors/feature_flags/feature_flags_selector'
import featureFlagsTypes from 'helpers/enums/featureFlagsTypes'

const featureFlagsSelector = featureFlagsSelectorCreator([
	featureFlagsTypes.INTERACTIVE_VIDEO_MCQ,
])

const interactiveVideoActivityPickerSelector = createSelector(
	[featureFlagsSelector],
	featureFlags => {
		const activityList = getActivityList()
		const activities = activityList.filter(
			activity => activity.flagType ? featureFlags[activity.flagType] : true
		)

		return {
			activities,
		}
	}
)

export default interactiveVideoActivityPickerSelector
